import { NavLink, Outlet } from "react-router-dom";
import { Inbox, Package, FileText, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "./AuthContext";
import { LogoMark } from "../components/Logo";

const TABS = [
  { to: "/admin", label: "Enquiries", icon: Inbox, id: "admin-tab-enquiries", end: true },
  { to: "/admin/products", label: "Products", icon: Package, id: "admin-tab-products", end: false },
  { to: "/admin/blog", label: "Blog", icon: FileText, id: "admin-tab-blog", end: false },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-slate-100" data-testid="admin-layout">
      <header className="sticky top-0 z-40 border-b border-slate-800 bg-navy" data-testid="admin-header">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-3.5 sm:px-8">
          <div className="flex items-center gap-3">
            <LogoMark className="h-8 w-auto" dark />
            <span className="hidden font-mono text-[9px] uppercase tracking-[0.2em] text-slate-400 sm:block">
              Admin Dashboard
            </span>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="admin-view-site-link"
              className="hidden items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400 hover:text-safety sm:flex"
            >
              <ExternalLink size={13} /> View site
            </a>
            <span className="hidden font-mono text-[10px] text-slate-500 md:block">{user?.email}</span>
            <button
              onClick={logout}
              data-testid="admin-logout-button"
              className="flex items-center gap-2 border border-slate-700 px-3.5 py-2 font-mono text-[10px] uppercase tracking-[0.16em] text-slate-300 transition-colors hover:border-safety hover:text-safety"
            >
              <LogOut size={13} /> Logout
            </button>
          </div>
        </div>
        <nav className="mx-auto flex max-w-7xl gap-1 px-5 sm:px-8">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={t.id}
              className={({ isActive }) =>
                `flex items-center gap-2 border-b-2 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "border-safety text-safety" : "border-transparent text-slate-400 hover:text-white"
                }`
              }
            >
              <t.icon size={14} /> {t.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-8 sm:px-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
